// 9fbef606107a605d69c0edbcd8029e5d
import throttle from 'lodash/throttle';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { breakpoints } from '@tcp/core/styles/themes/TCP/mediaQuery';
import { getProductDetails } from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.selectors';
import { getBrand } from '@tcp/core/src/utils/utils';
import {
  getRecommendationsObj,
  scrollPage,
  isClient,
  addBossUnavailableObj,
} from '../../../../../utils';
import BAGPAGE_CONSTANTS from '../BagPage.constants';

const getOffset = (elem) => {
  let x = 0;
  let y = 0;
  let el = elem;
  while (el && !Number.isNaN(el.offsetLeft) && !Number.isNaN(el.offsetTop)) {
    x += el.offsetLeft - el.scrollLeft;
    y += el.offsetTop - el.scrollTop;
    el = el.offsetParent;
  }
  return { top: y, left: x };
};

const getElementStickyPosition = (elem) => {
  return elem && getOffset(elem).top;
};

const bindScrollEvent = (callBack) => {
  const scrollThrottle = throttle(callBack, 100);
  if (isClient()) {
    window.addEventListener('scroll', scrollThrottle);
  }
  return () => window.removeEventListener('scroll', scrollThrottle);
};

const getPageLevelHeaderHeight = () => {
  return document.getElementsByClassName('condensed-header')[0]
    ? document.getElementsByClassName('condensed-header')[0].offsetHeight
    : 0;
};

const getProdBrand = (itemBrand) => {
  return itemBrand || getBrand();
};

const setFirstProductEvents = (index, summaryData, additionalInfoObj) => {
  if (index > 0) return {};
  return {
    giftCardAmount: summaryData && summaryData.giftCardsTotal,
    couponAmount: summaryData && summaryData.couponsTotal,
    shippingAmount: additionalInfoObj && additionalInfoObj.shippingAmount,
    savingsAmount: summaryData && summaryData.savingsTotal,
    taxAmount: summaryData && summaryData.taxesTotal,
    netRevenue: additionalInfoObj && additionalInfoObj.netRevenue,
  };
};

const getProductRecObjectIntoAnalyticsItems = async (productsData) => {
  const recObjs = await getRecommendationsObj();
  const bossUnavalableObject = await addBossUnavailableObj();
  const productColorId = (await productsData) && productsData[0] && productsData[0].partNumber;
  let productDataRecs = [];
  if (productColorId) {
    productDataRecs = await productsData.map((item) => {
      const recObj = (recObjs && recObjs[item.partNumber]) || {};
      const bossUnavalable = (bossUnavalableObject && bossUnavalableObject[item.partNumber]) || {};
      return {
        ...item,
        ...recObj,
        ...bossUnavalable,
      };
    });
  }

  return productDataRecs;
};

const getDimension158 = ({ colorConsolidationSV, productPartNumber, prodData }) => {
  const productData = prodData;
  if (Object.keys(colorConsolidationSV).length) {
    productData.dimension158 = colorConsolidationSV[productPartNumber] || '';
  }
  return productData;
};
const checkIfHomePageInYourCartProduct = (productPartNumber, sessionValue) => {
  const { PPIds } = sessionValue;
  return PPIds?.includes(productPartNumber);
};
const checkAndUpdateDimension81 = ({ sessionValue, productPartNumber, prodData, dimension }) => {
  const productData = { ...prodData };
  if ((productData && productData.dimension81) || isEmpty(sessionValue)) {
    return productData;
  }
  if (
    sessionValue &&
    Object.keys(sessionValue).length &&
    checkIfHomePageInYourCartProduct(productPartNumber, sessionValue)
  ) {
    productData[dimension] = sessionValue[dimension] || '';
  }
  return productData;
};

export const freeShippingPercentage = ({ shipments, freeShippingThreshold }) => {
  const shippingDetails = shipments?.filter((shipment) => shipment?.c_fromStoreId === null)[0];
  const shippingFreePercentage = (shippingDetails?.productTotal / freeShippingThreshold) * 100;
  const amountLeftToAttainFreeShipping = freeShippingThreshold - shippingDetails?.productTotal || 0;
  return {
    shippingFreePercentage,
    amountLeftToAttainFreeShipping,
  };
};

export const checkForFreeShipping = ({
  selectedShipmentCode,
  shipments,
  freeShippingThershold,
  isPDP,
  isQuickView,
  shippingTotal,
  isDynamicFreeShippingEnabled,
  orderType,
  productTotal,
  isShippingMethods,
}) => {
  if (isPDP || isQuickView) {
    if (isDynamicFreeShippingEnabled) {
      return '';
    }
    return true;
  }
  const shippingDetails = shipments?.filter((shipment) => {
    if (shipment.size) return shipment.get('c_fromStoreId') === null;
    return shipment?.c_fromStoreId === null;
  });
  let shippingDetailTotal;
  if (shippingDetails?.length > 0 || shippingDetails?.size) {
    shippingDetailTotal = shippingDetails?.size
      ? shippingDetails?.first()?.get('productTotal')
      : shippingDetails[0].productTotal;
  }
  const shippingCartAmount =
    orderType === 'ECOM' || orderType === 'PURE_ECOM' || orderType === 'ECOM_MIX'
      ? shippingDetailTotal
      : productTotal;
  const isShippingMethodPresent =
    BAGPAGE_CONSTANTS.FREE_SHIPMENT_CODES.includes(selectedShipmentCode);
  const isNonZeroShippingTotal = shippingTotal > 0;
  const isCartAmountBelowThreshold = shippingCartAmount < freeShippingThershold;
  if (
    (!isShippingMethods && isShippingMethodPresent && isNonZeroShippingTotal) ||
    isCartAmountBelowThreshold
  ) {
    return false;
  }

  return true;
};

const addDimensionIfProductPartNoAvailableInSV = ({
  sessionValue,
  productPartNumber,
  prodData,
  dimension,
}) => {
  const productData = { ...prodData };
  if (sessionValue && Object.keys(sessionValue).length) {
    productData[dimension] = sessionValue[productPartNumber] || '';
  }
  return productData;
};

const getDimension81 = ({ cd81Data, prodData, upc }) => {
  const productData = { ...prodData };
  if (Object.keys(cd81Data).length) {
    productData.dimension81 = cd81Data[upc] || '';
  }
  return productData;
};

const getAtcJourneyValue = ({ atcJourneyValue, productPartNumber }) =>
  atcJourneyValue && Object.keys(atcJourneyValue).length && atcJourneyValue[productPartNumber]
    ? atcJourneyValue?.productPartNumber
    : '';

export const bossUnavailableTracking = async (productPartNumber) => {
  return addBossUnavailableObj(productPartNumber);
};

const formatBagProductsData = (
  cartOrderItems,
  additionalInfoObj,
  confirmationPageLedgerSummaryData,
  isConfirmationPage
) => {
  const productsData = [];
  const {
    cd66Data = {},
    cd81Data = {},
    colorConsolidationSV = {},
    topRatedSV = {},
    bestSellerSV = {},
    nullSearchSV = {},
    bopisFavNonFavStoreValue = {},
    atcJourneyValue = {},
    hpInYourCartJourneyValue = {},
    esgBadgesSV = {},
    mostFavSV = {},
  } = additionalInfoObj || {};
  if (cartOrderItems) {
    cartOrderItems.map((tile, index) => {
      const productDetail = getProductDetails(tile);
      const {
        itemInfo: { color, name, offerPrice, size, listPrice, qty, itemBrand, wasPrice, salePrice },
        productInfo: { skuId, upc, productPartNumber, generalProductId, tcpStyleQty, tcpStyleType },
        miscInfo: {
          store,
          orderItemType,
          priceAdjustments,
          accessories,
          customizationType,
          availability,
        },
      } = productDetail;
      const summaryData = confirmationPageLedgerSummaryData || '';
      let prodData = {
        color,
        id: productPartNumber && productPartNumber.slice(0, productPartNumber.indexOf('_')),
        name,
        price: offerPrice,
        extPrice: offerPrice,
        paidPrice: offerPrice,
        listPrice,
        partNumber: productPartNumber,
        size,
        upc,
        sku: skuId.toString(),
        pricingState: 'full price',
        colorId: generalProductId,
        storeId: store,
        quantity: qty,
        availability,
        prodBrand: getProdBrand(itemBrand),
        shippingMethod: isConfirmationPage
          ? additionalInfoObj && additionalInfoObj.shippingMethod
          : null,
        ...setFirstProductEvents(index, summaryData, additionalInfoObj),
        orderItemType,
        priceAdjustments,
        accessories,
        customizationType,
        cd66: cd66Data[upc] || '',
        cd81: cd81Data[upc] || '',
        cd158: colorConsolidationSV[productPartNumber] || '',
        cd108: topRatedSV[productPartNumber],
        cd109: bestSellerSV[productPartNumber],
        cd139: mostFavSV[productPartNumber],
        cd122: nullSearchSV[productPartNumber],
        cd130: bopisFavNonFavStoreValue[productPartNumber],
        cd135: esgBadgesSV[productPartNumber],
        cd2: getAtcJourneyValue({ atcJourneyValue, productPartNumber }),
        wasPrice,
        salePrice,
        tcpStyleQty,
        tcpStyleType,
        ...addBossUnavailableObj(productPartNumber),
      };
      if (Object.keys(cd66Data).length) {
        prodData.dimension66 = cd66Data[upc] || '';
      }
      prodData = getDimension81({ cd81Data, prodData, upc });
      prodData = getDimension158({ colorConsolidationSV, productPartNumber, prodData });
      prodData = addDimensionIfProductPartNoAvailableInSV({
        sessionValue: topRatedSV,
        productPartNumber,
        prodData,
        dimension: 'dimension108',
      });
      prodData = addDimensionIfProductPartNoAvailableInSV({
        sessionValue: mostFavSV,
        productPartNumber,
        prodData,
        dimension: 'dimension139',
      });
      prodData = addDimensionIfProductPartNoAvailableInSV({
        sessionValue: bestSellerSV,
        productPartNumber,
        prodData,
        dimension: 'dimension109',
      });
      prodData = addDimensionIfProductPartNoAvailableInSV({
        sessionValue: nullSearchSV,
        productPartNumber,
        prodData,
        dimension: 'dimension122',
      });
      prodData = addDimensionIfProductPartNoAvailableInSV({
        sessionValue: bopisFavNonFavStoreValue,
        productPartNumber,
        prodData,
        dimension: 'dimension130',
      });
      prodData = addDimensionIfProductPartNoAvailableInSV({
        sessionValue: atcJourneyValue,
        productPartNumber,
        prodData,
        dimension: 'dimension2',
      });
      prodData = addDimensionIfProductPartNoAvailableInSV({
        sessionValue: esgBadgesSV,
        productPartNumber,
        prodData,
        dimension: 'dimension135',
      });
      prodData = checkAndUpdateDimension81({
        sessionValue: hpInYourCartJourneyValue,
        productPartNumber,
        prodData,
        dimension: 'dimension81',
      });
      productsData.push(prodData);
      return prodData;
    });
  }
  return productsData;
};

const formatBagCarousalData = (cartOrderItems) => {
  const productsData = [];

  if (cartOrderItems) {
    cartOrderItems.map((tile) => {
      const productDetail = getProductDetails(tile);
      const {
        itemInfo: { offerPrice, imagePath, itemBrand, quantity },
      } = productDetail;
      const prodData = {
        imagePath,
        price: offerPrice,
        itemBrand,
        quantity,
      };
      productsData.push(prodData);
      return prodData;
    });
  }
  return productsData;
};

const setBagPageAnalyticsData = (setClickAnalyticsDataBag, cartOrderItems, fromMiniBag) => {
  const productsData = formatBagProductsData(cartOrderItems);
  setClickAnalyticsDataBag({
    customEvents: ['scView', 'scOpen', 'event80'],
    products: productsData,
    pageNavigationText: fromMiniBag ? 'header-cart' : '',
  });
};

const getDefaultStateValues = () => {
  return {
    activeSection: null,
    showCondensedHeader: false,
    loadPaypalStickyHeader: false,
    showStickyHeaderMob: false,
    headerError: false,
    showPlaceCashRecommendation: false,
    isScrolling: false,
    scrollPos: -500,
    showPlaceRewardRecommendation: true,
    hasMounted: false,
    hasUpdateStoreApiCalled: true,
    hasTriggeredPriceDropNotification: false,
  };
};

const onPageUnload = () => {
  scrollPage();
};

const handleChangeActiveSection = (sectionName, scope) => {
  scope.setState({
    activeSection: sectionName,
  });
};

const isDeadlinePassed = (timerDeadlineValue, isExtendedHolidayReturnsBannerAbTestEnabled) => {
  const TIME_ZONE = 'America/New_York';
  const deadlineDate = new Date(timerDeadlineValue);
  const currentDate = new Date();
  const currentTimeEST = new Date(currentDate?.toLocaleString('en-US', { timeZone: TIME_ZONE }));

  if (deadlineDate < currentTimeEST && !isExtendedHolidayReturnsBannerAbTestEnabled) {
    return true;
  }
  return false;
};

const BagPagePropTypes = {
  className: PropTypes.string.isRequired,
  orderItemsCount: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  showAddTobag: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  isGuest: PropTypes.bool.isRequired,
  handleCartCheckout: PropTypes.func.isRequired,
  sflItems: PropTypes.shape([]).isRequired,
  setVenmoPaymentInProgress: PropTypes.func.isRequired,
  setApplePaymentInProgress: PropTypes.func.isRequired,
  isShowSaveForLaterSwitch: PropTypes.bool.isRequired,
  orderBalanceTotal: PropTypes.number.isRequired,
  bagStickyHeaderInterval: PropTypes.number.isRequired,
  currencySymbol: PropTypes.string.isRequired,
  isSflItemRemoved: PropTypes.bool.isRequired,
  isBagPage: PropTypes.bool.isRequired,
  cartItemSflError: PropTypes.string,
  bagPageServerError: PropTypes.shape({}),
  excludedIds: PropTypes.string,
  productId: PropTypes.string,
  isDisableBagAnchoring: PropTypes.bool,
  isMiniBagOpen: PropTypes.bool,
  setBackPackDeletedErrorAction: PropTypes.func,
  isOutfitsOnBagEnabled: PropTypes.bool,
  isLoyaltyTieringEnabled: PropTypes.bool,
};

const CarouselOptions = {
  CAROUSEL_OPTIONS: {
    arrows: true,
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 6,
    slide: true,
    touchMove: true,
    touchThreshold: 100,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: breakpoints.values.lg - 1,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: breakpoints.values.sm - 1,
        settings: {
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  },
  CAROUSEL_OPTIONS_REDESIGN: {
    arrows: true,
    infinite: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    slide: true,
    touchMove: true,
    touchThreshold: 100,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: breakpoints.values.lg - 1,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: breakpoints.values.sm - 1,
        settings: {
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  },
};

const PlacecashCarouselOptions = {
  CAROUSEL_OPTIONS: {
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    slide: true,
    dotsClass: 'slick-dots',
    dots: true,
    touchMove: true,
    touchThreshold: 100,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: breakpoints.values.lg - 1,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
        },
      },
      {
        breakpoint: breakpoints.values.sm - 1,
        settings: {
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  },
};

const getPageLevelHeaderNewHeight = () => {
  return document.getElementsByClassName('middle-nav-section')[0]
    ? document.getElementsByClassName('middle-nav-section')[0].offsetHeight
    : 0;
};

const convertUtcToLocal = (utcDateStr) => {
  // Parse the UTC date string into a Date object
  return new Date(utcDateStr);
};

// Utility to format a Date object as "YYYY-MM-DD"
const formatDateToYyyyMmDd = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getProductsWithPriceDropFlag = (
  products = [],
  sourceFlag = '',
  priceDropHolidayDateList = [],
  priceDropPercentageValue = 0
) => {
  if (!Array.isArray(products)) {
    return [];
  }

  return products.map((product) => {
    const lastViewedTime = product?.itemInfo?.lastViewedTime;
    const lastViewedPrice = Number(product?.itemInfo?.lastViewedPrice) || 0;
    const currentPrice = Number(product?.itemInfo?.itemUnitPrice) || 0;

    let hasPriceDropFlag;

    if (!lastViewedTime) {
      return { ...product, hasPriceDrop: false, source: sourceFlag };
    }

    const localDate = convertUtcToLocal(lastViewedTime);

    // Extract the date part (YYYY-MM-DD) from localDate
    const viewedDate = formatDateToYyyyMmDd(localDate);

    // Check if the date is in the priceDropHolidayDateList
    if (priceDropHolidayDateList && priceDropHolidayDateList.includes(viewedDate)) {
      hasPriceDropFlag = false;
    } else {
      // Calculate price drop percentage
      const priceDropPercent =
        lastViewedPrice > 0 ? ((lastViewedPrice - currentPrice) / lastViewedPrice) * 100 : 0;

      // Set flag based on price drop
      hasPriceDropFlag =
        priceDropPercent > 0 ? priceDropPercent >= priceDropPercentageValue : false;
    }
    return {
      ...product,
      hasPriceDrop: hasPriceDropFlag,
      source: sourceFlag,
    };
  });
};

const hasPriceChanged = (products) => {
  if (!Array.isArray(products)) {
    return false;
  }

  return products.some((product) => {
    const lastViewedPrice = product?.itemInfo?.lastViewedPrice;
    const currentPrice = Number(product?.itemInfo?.itemUnitPrice) || 0;

    // Return false if lastViewedPrice is undefined or null
    if (lastViewedPrice === undefined || lastViewedPrice === null) {
      return false;
    }

    // Convert lastViewedPrice to a number for comparison
    const lastViewedPriceNumber = Number(lastViewedPrice) || 0;

    return lastViewedPriceNumber !== currentPrice;
  });
};

const generatePriceDropPayload = (products) => {
  if (!Array.isArray(products)) {
    return false;
  }

  return products.map((product) => ({
    itemId: product?.itemInfo?.itemId || null,
    price: Number(product?.itemInfo?.itemUnitPrice) || 0,
  }));
};

export default {
  getElementStickyPosition,
  bindScrollEvent,
  getPageLevelHeaderHeight,
  setBagPageAnalyticsData,
  formatBagProductsData,
  getDefaultStateValues,
  onPageUnload,
  BagPagePropTypes,
  CarouselOptions,
  PlacecashCarouselOptions,
  handleChangeActiveSection,
  formatBagCarousalData,
  getProductRecObjectIntoAnalyticsItems,
  isDeadlinePassed,
  getPageLevelHeaderNewHeight,
  getProductsWithPriceDropFlag,
  hasPriceChanged,
  generatePriceDropPayload,
};
